export type TOCItem = { id: string; text: string; level: number }

function slugify(text: string): string {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
}

export function buildTOCFromHtml(html: string): { html: string; toc: TOCItem[] } {
  if (typeof window === 'undefined' || typeof (window as any).DOMParser === 'undefined') {
    // Fallback: naive heading extraction
    const toc: TOCItem[] = []
    return { html, toc }
  }
  try {
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')
    const toc: TOCItem[] = []
    const headings = Array.from(doc.querySelectorAll('h1, h2, h3')) as HTMLElement[]
    headings.forEach((h) => {
      const text = (h.textContent || '').trim()
      if (!text) return
      let id = h.id
      if (!id) {
        id = slugify(text)
        // Ensure uniqueness
        let unique = id
        let i = 2
        while (doc.getElementById(unique)) {
          unique = `${id}-${i++}`
        }
        id = unique
        h.id = id
      }
      const level = h.tagName === 'H1' ? 1 : h.tagName === 'H2' ? 2 : 3
      toc.push({ id, text, level })
    })
    const processed = doc.body.innerHTML
    return { html: processed, toc }
  } catch {
    return { html, toc: [] }
  }
}

